import React from 'react';
import ReactDOM from 'react-dom';
import RiskWarning from './components/risk-warning';
import SkuDialog from './components/sku-dialog-old';

// 详情插入提示
const RenderRick = () => {
  if (
    window._PAGE_SCHEMA_ &&
    JSON.stringify(window._PAGE_SCHEMA_).indexOf(`"consumeTip":"`)
  ) {
    let message = {};
    JSON.stringify(window._PAGE_SCHEMA_).replace(
      /"consumeTip":".[^"]+"/gi,
      $1 => {
        message = JSON.parse(`{${$1}}`);
      },
    );
    return <RiskWarning consumeTip={message.consumeTip} />;
  }
};

const detailDom = document.querySelector('[data-role="detail-tab-body"]');
const dom = document.createElement('div');
dom.className = 'risk-warn-layout';
detailDom.insertBefore(dom, detailDom.firstChild);
setTimeout(() => {
  ReactDOM.render(<RenderRick />, dom);
}, 1000);

// SKU 多样品采购
if (
  document.getElementById('J-btn-get-sample') &&
  document.getElementById('J-btn-get-sample').className.indexOf('disabled') ===
    -1
) {
  // if (document.getElementById('J-btn-get-sample')) {
  const buySample = document.createElement('span');
  ReactDOM.render(
    <SkuDialog text={document.getElementById('J-btn-get-sample').text} />,
    buySample,
  );
  const container = document.getElementById('J-btn-get-sample');
  container.replaceWith(buySample);
} else if (document.querySelector('[data-type="orderSample"]')) {
  const buySample = document.createElement('span');
  ReactDOM.render(
    <SkuDialog
      text={document.querySelector('[data-type="orderSample"]').textContent}
    />,
    buySample,
  );
  const container = document.querySelector('[data-type="orderSample"]');
  container.replaceWith(buySample);
}
